module.exports = __webpack_public_path__ + "static/media/cube.1c77c44f.png";